import React, { useState } from "react";
// import AuthLayout from "../../components/";
import {
  Layout,
  Col,
  Row,
  Button,
  Form,
  Input,
  message,
  Upload,
  Image,
  Checkbox,
  Modal,
} from "antd";
// import { UploadOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router";
import { Post } from "../../config/api/post";
import { Get } from "../../config/api/get";
import { USER_AUTH, TERMS } from "../../config/constants/api";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import Logo from "../../assets/luxurycarlogo.png";
import facebook from "../../assets/authfb.png";
import twitter from "../../assets/twitter.png";
import google from "../../assets/google.png";

import swal from "sweetalert";
import { Link } from "react-router-dom";
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 4;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
};

function CreateAccount() {
  // const { TextArea } = Input;
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [imageUrl, setImageUrl] = useState("");
  // const [imageObject, setImageObject] = useState(null);
  const [selfieUrl, setSelfieUrl] = useState("");
  const [selfieObject, setSelfieObject] = useState(null);

  // New document states
  const [dmvFrontUrl, setDmvFrontUrl] = useState("");
  const [dmvFrontObject, setDmvFrontObject] = useState(null);

  const [dmvBackUrl, setDmvBackUrl] = useState("");
  const [dmvBackObject, setDmvBackObject] = useState(null);

  const [tlcFrontUrl, setTlcFrontUrl] = useState("");
  const [tlcFrontObject, setTlcFrontObject] = useState(null);

  const [tlcBackUrl, setTlcBackUrl] = useState("");
  const [tlcBackObject, setTlcBackObject] = useState(null);

  const [insuranceUrl, setInsuranceUrl] = useState("");
  const [insuranceObject, setInsuranceObject] = useState(null);

  const [registerationUrl, setRegisterationUrl] = useState("");
  const [registerationObject, setRegisterationObject] = useState(null);

  const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);
  const [termsContent, setTermsContent] = useState("");
  const [loadingTerms, setLoadingTerms] = useState(false);

  // const handleChange2 = () => {
  //   swal("", "Congrats! You have been registered successfully", "success");
  // };

  // const handleChange = (value) => {
  //   console.log(`selected ${value}`);
  // };

  // const { Search } = Input;
  // const user = useSelector((state) => state.user.userData);
  // const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = React.useState(false);

  // const onChange = (date, dateString) => {
  //   console.log(date, dateString);
  // };

  // const { token } = theme.useToken();

  const fetchTermsAndConditions = () => {
    setLoadingTerms(true);
    Get(TERMS.getTerms)
      .then((response) => {
        if (response?.status && response?.data) {
          setTermsContent(response.data.content || response.data.text || "");
        } else {
          setTermsContent("Terms and conditions are not available at the moment.");
        }
        setLoadingTerms(false);
      })
      .catch((err) => {
        console.log("Error fetching terms and conditions:", err);
        setTermsContent("Failed to load terms and conditions. Please try again later.");
        setLoadingTerms(false);
      });
  };

  const handleOpenTermsModal = () => {
    setIsTermsModalVisible(true);
    if (!termsContent) {
      fetchTermsAndConditions();
    }
  };

  const onFinish = (values) => {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      password,
      bankTitle,
      bankAccountNo,
      routingNo,
      agreeToTerms,
    } = values;
    if (!selfieObject) {
      swal("Error", "Profile Image is Required", "error");
      return;
    }
    // New required document validations
    if (!dmvFrontObject) {
      swal("Error", "DMV Front image is required", "error");
      return;
    }
    if (!dmvBackObject) {
      swal("Error", "DMV Back image is required", "error");
      return;
    }
    if (!tlcFrontObject) {
      swal("Error", "TLC Front image is required", "error");
      return;
    }
    if (!tlcBackObject) {
      swal("Error", "TLC Back image is required", "error");
      return;
    }
    if (!insuranceObject) {
      swal("Error", "Insurance image is required", "error");
      return;
    }
    if (!registerationObject) {
      swal("Error", "Registerations image is required", "error");
      return;
    }
    setLoading(true);
    let data = new FormData();
    data.append("firstName", firstName);
    data.append("lastName", lastName);
    data.append("email", email);
    data.append("phone", "1"+phoneNumber);
    data.append("password", password);
    data.append("bankTitle", bankTitle);
    data.append("bankAccountNo", bankAccountNo);
    data.append("routingNo", routingNo);
    data.append("image", selfieObject);
    // New document fields
    data.append("dmvFront", dmvFrontObject);
    data.append("dmvBack", dmvBackObject);
    data.append("tlcFront", tlcFrontObject);
    data.append("tlcBack", tlcBackObject);
    data.append("insurance", insuranceObject);
    data.append("registeration", registerationObject);
    data.append("agreeToTerms", !!agreeToTerms);
    Post(USER_AUTH.signup, data, null, null, "multipart")
      .then((response) => {
        setLoading(false);
        // dispatch(
        //   addUser({ user: response.data?.user, token: response.data?.token })
        // );
        swal("Success!", response?.message, "success");
        navigate("/login");
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        setLoading(false);
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };


  const handleChangepro = (info, name) => {
    setLoading(true);
    getBase64(
      info?.fileList[info?.fileList?.length - 1]?.originFileObj,
      (url) => {
        if (name === "selfie") {
          setSelfieObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setSelfieUrl(url);
        } else if (name === "dmvFront") {
          setDmvFrontObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setDmvFrontUrl(url);
        } else if (name === "dmvBack") {
          setDmvBackObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setDmvBackUrl(url);
        } else if (name === "tlcFront") {
          setTlcFrontObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setTlcFrontUrl(url);
        } else if (name === "tlcBack") {
          setTlcBackObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setTlcBackUrl(url);
        } else if (name === "insurance") {
          setInsuranceObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setInsuranceUrl(url);
        } else if (name === "registeration") {
          setRegisterationObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setRegisterationUrl(url);
        }
        setLoading(false);
      }
    );
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );
  return (
    <Layout
      className=""
      style={{ backgroundColor: "#fff", minHeight: "100vh" }}
    >
      <div className="">
        <Row
          style={{
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Col xs={0} md={0} lg={12}>
            <div className="auth-left-bg new-auth-left-bg">
              <Link>
                <Image
                  preview={false}
                  alt={"Failed to load image"}
                  width={46}
                  height={46}
                  src={facebook}
                  style={{ maxWidth: "46px" }}
                />
              </Link>
              <Link>
                <Image
                  preview={false}
                  alt={"Failed to load image"}
                  width={46}
                  height={46}
                  src={twitter}
                  style={{ maxWidth: "46px" }}
                />
              </Link>
              <Link>
                <Image
                  preview={false}
                  alt={"Failed to load image"}
                  width={46}
                  height={46}
                  src={google}
                  style={{ maxWidth: "46px" }}
                />
              </Link>
            </div>
          </Col>
          <Col xs={23} md={23} lg={12}>
            <div
              className="auth-box"
              style={{ minHeight: "auto", height: "auto" }}
            >
              <div className="blur-bg-inner-card-form">
                <div style={{ textAlign: "center" }}>
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    width={110}
                    height={90}
                    src={Logo}
                    style={{ maxWidth: 100 }}
                  />
                </div>
                <h2 className="auth-heading">Sign Up</h2>
                <Form
                  className="row g-3"
                  name="basic"
                  layout="vertical"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Row
                    style={{ width: "100%", justifyContent: "center" }}
                    gutter={[16, 16]}
                    className="row-res-margin-0"
                  >
                    <Col lg={24} md={24} xs={24}>
                      <div
                        className="wrapper-group-1000001858"
                        style={{
                          height: "150px",
                          borderRadius: "100px",
                          width: "150px",
                          margin: "10px auto",
                        }}
                      >
                        <>
                          <Upload
                            name="image"
                            showUploadList={false}
                            style={{ position: "relative" }}
                            onChange={(e) => {
                              handleChangepro(e, "selfie");
                            }}
                            beforeUpload={beforeUpload}
                          >
                            {" "}
                            <div
                              style={{
                                height: "150px",
                                border: "1px solid gray",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                borderRadius: "100px",
                                width: "150px",
                                margin: "0 auto",
                              }}
                            >
                              {selfieUrl ? (
                                <img
                                  src={selfieUrl}
                                  alt="avatar"
                                  style={{
                                    width: "90%",
                                    height: "140px",
                                    objectPosition: "center",
                                    objectFit: "cover",
                                    borderRadius: "100px",
                                  }}
                                />
                              ) : (
                                uploadButton
                              )}
                            </div>{" "}
                          </Upload>
                        </>
                      </div>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <Form.Item
                        label="First Name"
                        name="firstName"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your first name!",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter First Name"
                          className="web-input"
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <Form.Item
                        label="Last Name"
                        name="lastName"
                        rules={[
                          {
                            required: true,
                            message: "Enter Last Name",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter Email Address"
                          className="web-input"
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <Form.Item
                        label="Email Address"
                        name="email"
                        rules={[
                          {
                            type: "email",
                            message: "Please enter a valid email address!",
                          },
                          {
                            required: true,
                            message: "Please enter your email address!",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="James.Anderson@gmail.com"
                          className="web-input"
                        />
                      </Form.Item>
                    </Col>
                    {/* <Col lg={12} md={12} xs={24}>
                      <Form.Item
                        label="Phone Number"
                        name="phoneNumber"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your phone number!",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter Phone Number"
                          className="web-input"
                        />
                      </Form.Item>
                    </Col> */}
                        <Col md={12} sm={24} xs={24}>
                  <p
                    className="font-euclid text-sm text-[#34324B] font-bold"
                    style={{ paddingBottom: "11px" }}
                  >
                    Phone Number
                  </p>
                  <div style={{ display: "flex" , width: "100%"}}>
                    <Input.Group compact style={{ maxWidth: "50px" }}>
                      <Input
                        value="+1"
                        disabled
                        className="h-12 text-sm font-euclid bg-gray-200 web-input"
                        style={{width: "50px", padding: "0 10px"}}
                      />
                    </Input.Group>
                    <Form.Item
                    style={{width: "100%"}}
                      name="phoneNumber"
                      rules={[
                        {
                          required: true,
                          message:
                            "Please enter your phone number (must be 10 digits long excluding +1)!",
                        },
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.reject(
                                "Please enter your phone number!"
                              );
                            }
                            if (!/^\d{10}$/.test(value)) {
                              return Promise.reject(
                                "Phone number must be exactly 10 digits (excluding +1)!"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        size="large"
                        placeholder="Enter Phone Number"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs w-full web-input"
                        style={{
                          MozAppearance: "textfield",
                          width: "100%",
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>
                    <Col lg={12} md={12} xs={24}>
                      <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Enter Password",
                          },
                        ]}
                      >
                        <Input.Password
                          size="large"
                          placeholder="Enter Password"
                          className="web-input"
                          style={{
                            borderRadius: "5px",
                            fontSize: "14px",
                            paddingRight: "10px",
                            backgroundColor: "transparent",
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <Form.Item
                        label="Confirm Password"
                        name="confirmPassword"
                        dependencies={["password"]}
                        rules={[
                          {
                            required: true,
                            message: "Please confirm your password!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("password") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error("The two passwords do not match!")
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          size="large"
                          placeholder="Confirm Password"
                          className="web-input"
                          style={{
                            borderRadius: "5px",
                            fontSize: "14px",
                            paddingRight: "10px",
                            backgroundColor: "transparent",
                          }}
                        />
                      </Form.Item>
                    </Col>
                    {/* New document uploads */}
                    <Col lg={12} md={12} xs={24}>
                      <label>DMV Front</label>
                      <div
                        className="wrapper-group-1000001858"
                        style={{
                          height: "200px",
                          borderRadius: "100px",
                          width: "100%",
                          margin: "0 auto",
                        }}
                      >
                        <>
                          <Upload
                            name="image"
                            showUploadList={false}
                            style={{ position: "relative" }}
                            onChange={(e) => {
                              handleChangepro(e, "dmvFront");
                            }}
                            beforeUpload={beforeUpload}
                          >
                            <div
                              style={{
                                height: "200px",
                                border: "1px solid gray",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "100%",
                                margin: "0 auto",
                              }}
                            >
                              {dmvFrontUrl ? (
                                <img
                                  src={dmvFrontUrl}
                                  alt="avatar"
                                  style={{
                                    width: "98%",
                                    height: "194px",
                                    objectPosition: "center",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                uploadButton
                              )}
                            </div>
                          </Upload>
                        </>
                      </div>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <label>DMV Back</label>
                      <div
                        className="wrapper-group-1000001858"
                        style={{
                          height: "200px",
                          borderRadius: "100px",
                          width: "100%",
                          margin: "0 auto",
                        }}
                      >
                        <>
                          <Upload
                            name="image"
                            showUploadList={false}
                            style={{ position: "relative" }}
                            onChange={(e) => {
                              handleChangepro(e, "dmvBack");
                            }}
                            beforeUpload={beforeUpload}
                          >
                            <div
                              style={{
                                height: "200px",
                                border: "1px solid gray",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "100%",
                                margin: "0 auto",
                              }}
                            >
                              {dmvBackUrl ? (
                                <img
                                  src={dmvBackUrl}
                                  alt="avatar"
                                  style={{
                                    width: "98%",
                                    height: "194px",
                                    objectPosition: "center",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                uploadButton
                              )}
                            </div>
                          </Upload>
                        </>
                      </div>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <label>TLC Front</label>
                      <div
                        className="wrapper-group-1000001858"
                        style={{
                          height: "200px",
                          borderRadius: "100px",
                          width: "100%",
                          margin: "0 auto",
                        }}
                      >
                        <>
                          <Upload
                            name="image"
                            showUploadList={false}
                            style={{ position: "relative" }}
                            onChange={(e) => {
                              handleChangepro(e, "tlcFront");
                            }}
                            beforeUpload={beforeUpload}
                          >
                            <div
                              style={{
                                height: "200px",
                                border: "1px solid gray",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "100%",
                                margin: "0 auto",
                              }}
                            >
                              {tlcFrontUrl ? (
                                <img
                                  src={tlcFrontUrl}
                                  alt="avatar"
                                  style={{
                                    width: "98%",
                                    height: "194px",
                                    objectPosition: "center",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                uploadButton
                              )}
                            </div>
                          </Upload>
                        </>
                      </div>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <label>TLC Back</label>
                      <div
                        className="wrapper-group-1000001858"
                        style={{
                          height: "200px",
                          borderRadius: "100px",
                          width: "100%",
                          margin: "0 auto",
                        }}
                      >
                        <>
                          <Upload
                            name="image"
                            showUploadList={false}
                            style={{ position: "relative" }}
                            onChange={(e) => {
                              handleChangepro(e, "tlcBack");
                            }}
                            beforeUpload={beforeUpload}
                          >
                            <div
                              style={{
                                height: "200px",
                                border: "1px solid gray",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "100%",
                                margin: "0 auto",
                              }}
                            >
                              {tlcBackUrl ? (
                                <img
                                  src={tlcBackUrl}
                                  alt="avatar"
                                  style={{
                                    width: "98%",
                                    height: "194px",
                                    objectPosition: "center",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                uploadButton
                              )}
                            </div>
                          </Upload>
                        </>
                      </div>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <label>Insurance</label>
                      <div
                        className="wrapper-group-1000001858"
                        style={{
                          height: "200px",
                          borderRadius: "100px",
                          width: "100%",
                          margin: "0 auto",
                        }}
                      >
                        <>
                          <Upload
                            name="image"
                            showUploadList={false}
                            style={{ position: "relative" }}
                            onChange={(e) => {
                              handleChangepro(e, "insurance");
                            }}
                            beforeUpload={beforeUpload}
                          >
                            <div
                              style={{
                                height: "200px",
                                border: "1px solid gray",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "100%",
                                margin: "0 auto",
                              }}
                            >
                              {insuranceUrl ? (
                                <img
                                  src={insuranceUrl}
                                  alt="avatar"
                                  style={{
                                    width: "98%",
                                    height: "194px",
                                    objectPosition: "center",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                uploadButton
                              )}
                            </div>
                          </Upload>
                        </>
                      </div>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <label>Registerations</label>
                      <div
                        className="wrapper-group-1000001858"
                        style={{
                          height: "200px",
                          borderRadius: "100px",
                          width: "100%",
                          margin: "0 auto",
                        }}
                      >
                        <>
                          <Upload
                            name="image"
                            showUploadList={false}
                            style={{ position: "relative" }}
                            onChange={(e) => {
                              handleChangepro(e, "registeration");
                            }}
                            beforeUpload={beforeUpload}
                          >
                            <div
                              style={{
                                height: "200px",
                                border: "1px solid gray",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "100%",
                                margin: "0 auto",
                              }}
                            >
                              {registerationUrl ? (
                                <img
                                  src={registerationUrl}
                                  alt="avatar"
                                  style={{
                                    width: "98%",
                                    height: "194px",
                                    objectPosition: "center",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                uploadButton
                              )}
                            </div>
                          </Upload>
                        </>
                      </div>
                    </Col>

                    <Col lg={24} md={24} xs={24}>
                      <h3>Payment Info</h3>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <Form.Item
                        label="Name of Bank"
                        name="bankTitle"
                        rules={[
                          {
                            required: true,
                            message: "Please enter Name of Bank!",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter Name of Bank"
                          className="web-input"
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} xs={24}>
                      <Form.Item
                        label="Bank Account Number"
                        name="bankAccountNo"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your Account Number!",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter Account Number"
                          className="web-input"
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={24} md={24} xs={24}>
                      <Form.Item
                        label="Routing Number"
                        name="routingNo"
                        rules={[
                          {
                            required: true,
                            message: "Please enter Routing Number!",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter Routing Number"
                          className="web-input"
                        />
                      </Form.Item>
                    </Col>

                    <Col lg={24} md={24} xs={24}>
                      <Form.Item
                        name="agreeToTerms"
                        valuePropName="checked"
                        rules={[
                          {
                            validator: (_, value) =>
                              value
                                ? Promise.resolve()
                                : Promise.reject(
                                    new Error(
                                      "You must agree to the terms and conditions"
                                    )
                                  ),
                          },
                        ]}
                      >
                        <Checkbox>
                          I agree to the{" "}
                          <span
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={handleOpenTermsModal}
                          >
                            terms and conditions
                          </span>
                        </Checkbox>
                      </Form.Item>
                    </Col>

                    <div className="" style={{ textAlign: "center" }}>
                      <Button
                        type=""
                        htmlType="submit"
                        className="btn web-btn px-5"
                        disabled={loading}
                        // onClick={() => navigate("/dashboard")}
                      >
                        {!loading ?  'Signup' : '...loading'}
                      </Button>
                      <div
                        className="already-account-text"
                        style={{ textAlign: "center", cursor: "pointer" }}
                      >
                        Already Have An Account?{" "}
                        <span onClick={() => navigate("/")}>Login</span>{" "}
                      </div>
                    </div>
                    {/* <Col lg={24} xs={24} className="signup-with-buttons">
                      <Divider>OR</Divider>
                      <div className="g-btn">
                        <a href="#_" className="signup-with-btn">
                          <Image
                            preview={false}
                            alt={"Failed to load image"}
                            src={fbicn}
                            className=""
                          />
                          Signup with Facebook
                        </a>
                        <a href="#_" className="signup-with-btn">
                          <Image
                            preview={false}
                            alt={"Failed to load image"}
                            src={gogoleicn}
                            className=""
                          />
                          Signup with Google
                        </a>
                      </div>
                    </Col> */}
                  </Row>
                </Form>
                <div className="responsive-auth-social-icon">
                  <Link>
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      width={46}
                      height={46}
                      src={facebook}
                      style={{ maxWidth: "46px" }}
                    />
                  </Link>
                  <Link>
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      width={46}
                      height={46}
                      src={twitter}
                      style={{ maxWidth: "46px" }}
                    />
                  </Link>
                  <Link>
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      width={46}
                      height={46}
                      src={google}
                      style={{ maxWidth: "46px" }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Modal
          title="Terms and Conditions"
          open={isTermsModalVisible}
          onOk={() => setIsTermsModalVisible(false)}
          onCancel={() => setIsTermsModalVisible(false)}
          footer={null}
          width={700}
        >
          <div style={{ maxHeight: 500, overflowY: "auto", padding: "10px 0" }}>
            {loadingTerms ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                Loading terms and conditions...
              </div>
            ) : termsContent ? (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  lineHeight: "1.6",
                  fontSize: "14px",
                }}
                dangerouslySetInnerHTML={{ __html: termsContent }}
              />
            ) : (
              <p>Terms and conditions are not available at the moment.</p>
            )}
          </div>
        </Modal>
      </div>
    </Layout>
  );
}

export default CreateAccount;
